<!-- @format -->

<template>
  <div>
    <h4>My team shares {{ count }}</h4>
    <h4>My All team{{ all }}</h4>
    <vue-ads-table :columns="columns" :rows="rows" :filterable="true" @filter-change="filterChanged">
      <template slot="toggle-children-icon" slot-scope="props">
        <feather-icon size="24" icon="MinusIcon" v-if="props.expanded" style="box-shadow: 0 0 10rpx #ccc" />
        <feather-icon size="24" icon="PlusIcon" v-else />
      </template>
      <template slot="level" slot-scope="props">{{ props.row.level.name }}</template>
    </vue-ads-table>
  </div>
</template>

<script>
import VueAdsTable from 'vue-ads-table-tree'
import 'vue-ads-table-tree/dist/vue-ads-table-tree.css'
import axiosIns from '@/libs/axios'

export default {
  name: 'BasicTableApp',
  components: {
    VueAdsTable,
  },
  data() {
    return {
      count: 0,
      page: 0,
      filter: '',
      all: '',
      columns: [
        {
          title: 'Selection',
          collapseIcon: true,
        },
        {
          title: 'User Id',
          property: 'id',
        },
        {
          property: 'name',
          title: 'Agent Name',
          // collapseIcon: true,
        },
        {
          property: 'level',
          title: 'Agent Level',
        },
        {
          property: 'created_at',
          title: 'Register Time',
        },
      ],
      rows: [],
      name: '',
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchData()
      // document.querySelector('input.vue-ads-p-2').style.display = 'none'
    })
  },
  methods: {
    // 递归计算树菜单一共出现多少个节点
    countNodes(data) {
      let count = 0
      data.forEach(item => {
        if (item._children) {
          count += this.countNodes(item._children)
        } else {
          count++
        }
      })
      return count
    },
    // 将树展开为一维数组
    flatten(data) {
      const result = []
      data.forEach(item => {
        if (item._children) {
          result.push(...this.flatten(item._children))
        } else {
          result.push(item)
        }
      })
      return result
    },

    filterChanged(filter) {
      this.name = filter
      this.fetchData()
      // this.filter = filter
    },
    fetchData() {
      axiosIns.get(`/user/childrenUser2?name=${this.name}`).then(response => {
        // 递归 替换树结构中所有 child 字段为 _children 字段
        const result = function (data) {
          const newData = []
          data.forEach(item => {
            if (item.child) {
              item._children = result(item.child)
              delete item.child
            }
            newData.push(item)
          })
          return newData
        }
        this.rows = result(response.data.list ? response.data.list : response.data)
        // this.count = this.countNodes(this.rows)
        this.count = response.data.child
        this.all = response.data.all || 0
      })
    },

    pageChanged(page) {
      this.page = page
    },
  },
}
</script>

<style></style>
